import React, { useRef, useState, FunctionComponent, useEffect } from 'react'
import MUIRichTextEditor from 'mui-rte'

import Grid from '@material-ui/core/Grid'
import { makeStyles } from '@material-ui/core/styles'
import Popover from '@material-ui/core/Popover'
import TextField from '@material-ui/core/TextField'

import DraftJsService from "../../../../services/DraftJsService";

// Icons
import InsertEmoticonIcon from '@material-ui/icons/InsertEmoticon';
import GifIcon from '@material-ui/icons/Gif';
import AttachFileIcon from '@material-ui/icons/AttachFile'
import IconButton from '@material-ui/core/IconButton'
import Button from '@material-ui/core/Button'
import DoneIcon from '@material-ui/icons/Done'
import CloseIcon from '@material-ui/icons/Close'
import SendIcon from '@material-ui/icons/Send';
import AttachmentIcon from '@material-ui/icons/Attachment';

// Draft js
import { EditorState, Modifier, convertToRaw, AtomicBlockUtils } from 'draft-js'

// Giphy select
import GiphySelect from 'react-giphy-select';
import 'react-giphy-select/lib/styles.css';
// Airbnb outside-click-handler
import OutsideClickHandler from 'react-outside-click-handler';
// Emoji picker
import "emoji-mart/css/emoji-mart.css";
import { Picker } from "emoji-mart";

import './Editor.css'
import { storage } from "../../../../firebase/firebase";
// import { ContentState } from 'draft-js'


const cardPopverStyles = makeStyles({
  root: {
    padding: 10,
    maxWidth: 350
  },
  textField: {
    width: "100%",
    input: {
      "&::placeholder": {
        color: "black"
      },
    }
  },
  input: {
    display: "none"
  }
})


async function uploadImageToServer(file: File, channelId) {

  let image = file;
  let path = 'channels/' + channelId;
  let imagePath = path + "/" + file.name;

  const uploadTask = storage.ref(imagePath).put(image);

  return new Promise((resolve, reject) => {
    uploadTask.on(
      "state_changed",
      (snapshot) => {
        // progress function ...
        // const progress = Math.round(
        //     (snapshot.bytesTransferred / snapshot.totalBytes) * 100
        // );
        //this.setState({ progress });
      },
      (error) => {
        // Error function ...
        reject(Error(error));
      },
      () => {
        // complete function ...
        storage
          .ref(path)
          .child(image.name)
          .getDownloadURL()
          .then((url) => {
            console.log(url)
            resolve(url)
          });
      }
    );

  })

}



// Image upload --------------------------------------------------------------------------------------------------------

const uploadImage = (file: File, height, width, channelId) => {
  return new Promise(async (resolve, reject) => {
    const url = await uploadImageToServer(file, channelId)
    if (!url) {
      reject()
      return
    }

    // This double loading of the image for retrieving width and height will be redundant upon replacing mui-rte ufile uploader
    var img = new Image();
    img.addEventListener("load", function () {

      // Max image height of 500
      const height = (img.height > 250) ? 250 : img.height;
      // If we topped out our max image height, leave width alone to maintain aspect ratio
      const width = (img.height > 250) ? null : img.width;

      resolve({
        data: {
          url: url,
          width: width,
          height: height,
          alignment: "left", // or "center", "right"
          type: "image" // or "video"
        }
      })

    });
    img.src = url;

  })
}

const UploadImagePopover: FunctionComponent = (props) => {

  const classes = cardPopverStyles(props);
  const [state, setState] = useState({
    anchor: null,
    isCancelled: false
  })
  const [data, setData] = useState({})

  useEffect(() => {
    setState({
      anchor: props.anchor,
      isCancelled: false
    })
    setData({
      file: undefined
    })
  }, [props.anchor])

  return (

    <Popover
      anchorEl={state.anchor}
      open={state.anchor !== null}
      onExited={() => {
        props.onSubmit(data, !state.isCancelled)
      }}
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "right"
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'left',
      }}
    >
      <div class={'popover'}>
        <Grid container spacing={1} className={classes.root} >
          <Grid item xs={10}>
            <TextField
              className={classes.textField}
              disabled
              value={data.file?.name || ""}
              placeholder="Click icon to attach image"
            />
          </Grid>
          <Grid item xs={2}>
            <input
              accept="image/*"
              className={classes.input}
              id="contained-button-file"
              type="file"
              onChange={(event) => {
                setData({
                  ...data,
                  file: event.target.files[0]
                })
              }}
            />
            <label htmlFor="contained-button-file">
              <IconButton aria-label="upload image" component="span">
                <AttachFileIcon color={"primary"} />
              </IconButton>
            </label>
          </Grid>
          <Grid item container xs={12} justify="flex-end">
            <Button onClick={() => {
              setState({
                anchor: null,
                isCancelled: true
              })
            }}
            >
              <CloseIcon color={"primary"} />
            </Button>
            <Button onClick={() => {
              setState({
                anchor: null,
                isCancelled: false
              })
            }}
            >
              <DoneIcon color={"primary"} />
            </Button>
          </Grid>
        </Grid>
      </div>
    </Popover>
  )
}

const RichEditor: FunctionComponent = (props) => {

  const { channelId, sendMessage } = props;

  const ref = useRef(null)
  useEffect(() => {
    ref.current?.focus()
  })

  const [anchor, setAnchor] = useState(null)

  const handleFileUpload = (file: File) => {
    ref.current?.insertAtomicBlockAsync("IMAGE", uploadImage(file, channelId), "Uploading now...")
  }

  // Initialise our custom editor state
  // This is NOT the main editorState used by mui-rte's draft-js instance, but a custom state var used for taking a snapshot of the editor's state
  // when using custom controls such as the emoji picker.
  const [editorState, setEditorState] = React.useState(
    () => EditorState.createEmpty(),
  );

  // Update editor display value. At present, this must be a RAW version of a ContentState object.
  // This should be replaced entirely with our own implementation of draft-js
  const updateEditorDisplay = (content) => {
    // setEditorState(content)
    return JSON.stringify(convertToRaw(content))
  }
  const editorDisplayValue = updateEditorDisplay(editorState.getCurrentContent())



  // Giphy picker ------------------------------------------------------------------------------------------------------

  const [giphyPickerState, SetGiphyPicker] = useState(false);

  const onGifSelect = (entry) => {
    //todo: perform any other logic here besides the media append
    appendGiphyMedia(entry);
    SetGiphyPicker(false);
  }

  let giphyPicker;
  if (giphyPickerState) {
    giphyPicker = (
      <div className={'giphy-picker'}>
        <div className={'giphy-picker-content'}>
          <OutsideClickHandler
            onOutsideClick={() => {
              SetGiphyPicker(false)
            }}
          >
            <GiphySelect
              onEntrySelect={onGifSelect}
              requestKey={'QuTptJCreTb6LWlJZck4yZ3rnGheW51W'}
              theme={{attribution: 'giphyAttribution'}}
            />
          </OutsideClickHandler>
        </div>
      </div>
    );

  }







  // Emoji picker ------------------------------------------------------------------------------------------------------
  let emojiPicker;

  // Initialise emoji picker
  const [emojiPickerState, SetEmojiPicker] = useState(false);

  if (emojiPickerState) {
    emojiPicker = (
      <div class={'emojiPicker'}>

        <OutsideClickHandler
          onOutsideClick={() => {
            SetEmojiPicker(false)
          }}
        >
          <Picker
            title="Pick your emoji…"
            theme={'dark'}
            emoji="point_up"
            // onSelect={emoji => SetMessage(message + emoji.native)}
            onSelect={emoji => appendText(emoji.native)}
          />

        </OutsideClickHandler>
      </div>
    );
  }

  // Content update methods --------------------------------------------------------------------------------------------

  // Append given string to our custom editorState var
  function appendText(text) {
    const currentContent = editorState.getCurrentContent(),
      currentSelection = editorState.getSelection();

    const newContent = Modifier.replaceText(
      currentContent,
      currentSelection,
      text
    );
    const newEditorState = EditorState.push(editorState, newContent, 'insert-characters');
    setEditorState(newEditorState);
  }


  // Function to manually append either image or video to mui-rte draft-js instance
  // note: if mui-rte's media control is enabled, adding media via this method will trigger the 'add media' popup when appending content state
  function appendGiphyMedia(giphyEntry) {

    const sourceKey = giphyEntry.images.fixed_width.hasOwnProperty('url') ? 'url' : 'mp4'
    const sourceType = sourceKey === 'url' ? 'image' : 'video';
    const entityData = {
      url: giphyEntry.images.fixed_width[sourceKey],
      width: giphyEntry.images.fixed_width.width,
      height: giphyEntry.images.fixed_width.height,
      alignment: "left", // or "center", "right"
      type: sourceType // or "video"
    }

    const contentStateWithEntity = editorState.getCurrentContent().createEntity('IMAGE', 'IMMUTABLE', entityData);

    const entityKey = contentStateWithEntity.getLastCreatedEntityKey();
    let newEditorState = EditorState.set(editorState, { currentContent: contentStateWithEntity },);

    setEditorState(newEditorState);
    newEditorState = AtomicBlockUtils.insertAtomicBlock(editorState, entityKey, ' ');
    setEditorState(newEditorState);

  }


  // The 'on save' handler used to sending editor content as message, whether onclick, or on Enter
  const handleOnSave = (data) => {
    let content = JSON.stringify(convertToRaw(data.getCurrentContent(), null, 2))
    // let contentState = editorState.getCurrentContent();
    if ((new DraftJsService()).contentIsNotEmpty(convertToRaw(data.getCurrentContent()))) {
      sendMessage(content)
      setEditorState(EditorState.createEmpty())
    }

  }

  // Custom 'save button component'
  // This is required so that we can set a ref against the button, then use this to grab the underlying input
  // in order to programtically trigger the onClick() on enter key-press
  let saveButtonRef = useRef()
  const customSaveButtonComponent = (props) => {
    return (
      <IconButton
        id={props.id}
        variant="contained"
        ref={saveButtonRef}
        onClick={props.onMouseDown}
      >
        <SendIcon fontSize="small" color="primary" />
      </IconButton>
    )
  }


  const editor = <>
    <UploadImagePopover
      anchor={anchor}
      onSubmit={(data, insert) => {
        if (insert && data.file) {
          console.log(data)
          handleFileUpload(data.file)
        }
        setAnchor(null)
      }}
    />
    <MUIRichTextEditor
      ref={ref}
      value={editorDisplayValue}
      label="Start typing..."
      toolbarButtonSize={'small'}
      controls={["bold", "italic", "underline", "strikethrough", "colour", "insert-emoticon", "upload-image", "insert-giphy", "manual-save"]}
      customControls={[
        {
          name: "insert-emoticon",
          icon: <InsertEmoticonIcon />,
          type: "callback",
          onClick: (editorState, name, anchor) => {
            setEditorState(editorState)
            SetEmojiPicker(!emojiPickerState);
          }
        },
        {
          name: "insert-giphy",
          icon: <GifIcon />,
          type: "callback",
          onClick: (editorState, name, anchor) => {
            setEditorState(editorState)
            SetGiphyPicker(!giphyPickerState);
          }
        },
        {
          name: "upload-image",
          icon: <AttachmentIcon />,
          type: "callback",
          onClick: (_editorState, _name, anchor) => {
            setAnchor(anchor)
          }
        },
        {
          name: "manual-save",
          // icon: <SendIcon />,
          type: "callback",
          component: customSaveButtonComponent,
          onClick: (editorState, name, anchor) => {
            handleOnSave(editorState)
          }
        }
      ]}
      draftEditorProps={{
        handleDroppedFiles: (_selectionState, files) => {
          if (files.length && files[0].name !== undefined) {
            handleFileUpload(files[0])
            return "handled"
          }
          return "not-handled"
        }
      }}
    />
  </>


  // Register our enter key press listener
  const keyUpHandler = (event) => {
    if (event.keyCode === 13) {
      if (!event.shiftKey) {

        saveButtonRef.current.click()
      }
    }
  }
  //isolate the event or the listener
  //notranslate public-DraftEditor-content

  useEffect(() => {
    //change this to my input or listen to global 
    window.addEventListener('keyup', keyUpHandler);
    // Remove event listeners on cleanup
    return () => {
      window.removeEventListener('keyup', keyUpHandler);
    };
  }, []); // Empty array ensures that effect is only run on mount and unmount


  return (
    <div>
      {giphyPicker}
      {emojiPicker}
      {editor}
    </div>
  )
}

export default RichEditor